import {Component, Input} from '@angular/core';

@Component({
  selector: 'digires-stage-matrix-progress',
  templateUrl: './stage-matrix-progress.component.html',
  styleUrls: ['./stage-matrix-progress.component.scss']
})
export class StageMatrixProgressComponent {

  @Input() icon: string;
  @Input() label: string;
  @Input() tooltip: string;
  @Input() value: string;
  @Input() textScale = 100;

}
